<div class="progress-container">
  <ng-container *ngFor="let item of progression; let i = index; last as isLast; trackBy: trackByPageName">
    <ng-container>
      <div class="step-wrapper">
        <div class="step">
          <div
            class="circle"
            [ngClass]="{
              done: item.finished,
              active: !item.finished && i === firstUnfinishedIndex
            }"
          ></div>
          <p>{{ translatePageProgressName(item.pageName) }}</p>
        </div>
      </div>
      <div
        *ngIf="!isLast"
        class="line"
        [ngClass]="{
          done: item.finished
        }"
      ></div>
    </ng-container>
  </ng-container>
</div>
